module.exports = __webpack_public_path__ + "static/Demo-7473326982235a846e10b2bbad8825e8.pdf";